export const PERMISSIONS = {
  MANAGE_COMPANY_LISTS: 'manageCompanyLists',
  MANAGE_USERS: 'manageUsers',
  DATA_CORRECTION_UPLOADER: 'dataCorrectionUploader',
  DATA_CORRECTION_APPROVER: 'dataCorrectionApprover',
  USER_SSO: 'userSSO',
  ADD_CREDITS_TO_WORKSPACE: 'addCreditsToWorkspace',
  VIEW_AUDIT_LOGS: 'viewAuditLogs',
  MANAGE_SIGNUP_BLACKLIST: 'manageSignupBlacklist',
  MANAGE_PUBLIC_IMAGES: 'managePublicImages',
  CHANGE_SUBSCRIPTION: 'changeSubscription',
  MANAGE_WHATS_NEW: 'manageWhatsNew',
  VIEW_SKYLAR_THREADS: 'viewSkylarThreads',
  // VIEW_AGENT_ANALYTICS: 'viewAgentAnalytics',
};

export const PERMISSION_DESCRIPTIONS = {
  [PERMISSIONS.MANAGE_COMPANY_LISTS]: 'Can view and manage company lists',
  [PERMISSIONS.MANAGE_USERS]: 'Can manage users and permissions',
  [PERMISSIONS.DATA_CORRECTION_UPLOADER]: 'Can upload data correction CSVs',
  [PERMISSIONS.DATA_CORRECTION_APPROVER]: 'Can approve or reject uploads',
  [PERMISSIONS.USER_SSO]: 'Can generate SSO login links for users',
  [PERMISSIONS.ADD_CREDITS_TO_WORKSPACE]: 'Can add credits to workspaces',
  [PERMISSIONS.VIEW_AUDIT_LOGS]: 'Can view audit logs and system activity',
  [PERMISSIONS.MANAGE_SIGNUP_BLACKLIST]: 'Can manage signup email domain blacklist, disposable lists, and email verify whitelist',
  [PERMISSIONS.MANAGE_PUBLIC_IMAGES]: 'Can manage public images in GCP Cloud Storage',
  [PERMISSIONS.CHANGE_SUBSCRIPTION]: 'Can change workspace subscription',
  [PERMISSIONS.MANAGE_WHATS_NEW]: 'Can manage whats new module',
  [PERMISSIONS.VIEW_SKYLAR_THREADS]: "Can view Skylar's Threads (AI CS Agent)",
  // [PERMISSIONS.VIEW_AGENT_ANALYTICS]: "Can view GTM agent analytics and customers' agent conversations",
};

export const hasPermission = (user, permission) => {
  if (!user || !user.permissions) {
    return false;
  }
  return user.permissions.includes(permission);
};

export const hasAnyPermission = (user, permissions) => {
  if (!user || !user.permissions) {
    return false;
  }
  return permissions.some(permission => user.permissions.includes(permission));
};

export const hasAllPermissions = (user, permissions) => {
  if (!user || !user.permissions) {
    return false;
  }
  return permissions.every(permission => user.permissions.includes(permission));
};

